export const colors = {
  primary: {
    base: '#74BF00',
    lighter: '#78DB14',
    light: '#67BA13',
    dark: ' #63A204',
    darker: '#467302',
  },
  secondary: {
    base: '#EFA329',
    light: '#FFA97C',
    other: '#EDC255',
  },
  blue: {
    500: '#EFA329',
  },
  gray: {
    regular: '#333333',
    light: '#697386',
    900: '#565656',
    800: '#676767',
    700: '#787878',
    600: '#898989',
    500: '#9A9A9A',
    400: '#8792A2',
    300: '#BBBBBB',
    200: '#CCCCCC',
    100: '#DDDDDD',
    50: '#EEEEEE',
    '50-0': '#F7FAFC',
    soft: '#F7F7F7',
  },
  log: {
    error: '#E41B1B',
    success: '#00AF85',
    info: '#EDA736',
    warning: '#FFA97C',
  },
  border: {
    default: '#D7D7D7',
  },
  text: {
    default: '#3F3D3C',
    icon: '#717171',
  },
}
